import React from 'react'
import "./ChooseUs.css"
import { Card, Col, Container, Row } from 'reactstrap'
import features1 from "../assets/images/features/img-1.png";
import features2 from "../assets/images/features/img-2.png";

const ChooseUs = () => {
    return (
        <React.Fragment>
            <section className="section" id="features">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="text-center">
                                <h1 className="display-5 fw-normal fw-bold">
                                    Why Choose Us
                                </h1>
                                <p className="mt-4 fw-bold">
                                    Trusted solutions designed to deliver speed, quality, and value.</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className="pt-4 align-items-center">
                        <Col lg={5}>
                            <div className="mt-4">
                                <h3>
                                    <span className="fw-normal">Reasons that make us </span>
                                    stand out
                                </h3>
                                <div className="mt-4 pt-3">
                                    <div className="d-flex">
                                        <div className="features-count">
                                            <h5 className="f-14 text-primary">01</h5>
                                        </div>
                                        <div className="flex-1 ps-3">
                                            <h5 className="f-18 mt-1">
                                                Strong industrial application experience
                                            </h5>
                                            <p className="text-muted mt-2">
                                                Proven expertise in delivering robust and scalable industrial-grade applications.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="d-flex mt-3">
                                        <div className="features-count">
                                            <h5 className="f-14 text-primary">02</h5>
                                        </div>
                                        <div className="flex-1 ps-3">
                                            <h5 className="f-18 mt-1">Faster time to market</h5>
                                            <p className="text-muted mt-2">
                                                Accelerated development cycles without compromising quality.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="d-flex mt-3">
                                        <div className="features-count">
                                            <h5 className="f-14 text-primary">03</h5>
                                        </div>
                                        <div className="flex-1 ps-3">
                                            <h5 className="f-18 mt-1">
                                                Vendor-neutral solution design
                                            </h5>
                                            <p className="text-muted mt-2">
                                                Flexible architectures that avoid vendor lock-in.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={6} className="offset-lg-1">
                            <div className="mt-4 p-5">
                                <img src={features1} className="img-fluid" alt="" />
                            </div>
                        </Col>
                    </Row>
                    <Row className="align-items-center">
                        <Col lg={6}>
                            <div className="mt-4 p-5">
                                <img src={features2} className="img-fluid" alt="" />
                            </div>
                        </Col>
                        <Col lg={5}>
                            <div className="mt-4">
                                <div className="mt-4 pt-3">
                                    <div className="d-flex mt-3">
                                        <div className="features-count">
                                            <h5 className="f-14 text-primary">04</h5>
                                        </div>
                                        <div className="flex-1 ps-3">
                                            <h5 className="f-18 mt-1">Cost-effective systems</h5>
                                            <p className="text-muted mt-2">
                                                Optimized solutions that reduce operational and maintenance costs.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="d-flex mt-3">
                                        <div className="features-count">
                                            <h5 className="f-14 text-primary">05</h5>
                                        </div>
                                        <div className="flex-1 ps-3">
                                            <h5 className="f-18 mt-1">Fast feasibility studies</h5>
                                            <p className="text-muted mt-2">
                                                Quick assessments to validate ideas and technical approaches.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="d-flex mt-3">
                                        <div className="features-count">
                                            <h5 className="f-14 text-primary">06</h5>
                                        </div>
                                        <div className="flex-1 ps-3">
                                            <h5 className="f-18 mt-1">
                                                On-site & remote support
                                            </h5>
                                            <p className="text-muted mt-2">
                                                Reliable assistance wherever your team is located.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>


                    </Row>
                </Container>
            </section>

        </React.Fragment>
    )
}

export default ChooseUs;